<template>
  <div>

    <add-manning-history></add-manning-history>

    <table class="table table-hover table-bordered table-template-1 my-2 text-small">
      <thead>
      <tr>
        <th>#</th>
        <th>DATE TRANSFERRED</th>
        <th>MANNING FROM</th>
        <th>MANNING TO</th>
        <th class="col-actions" style="width: 10%;">ACTION</th>
      </tr>
      </thead>

      <tbody>
      <tr v-if="isLoading">
        <td colspan="100%">
          <app-loading></app-loading>
        </td>
      </tr>
      <template v-else>
        <tr v-for="(vesselManningHistory, index) in vesselManningHistories" :key="vesselManningHistory.id">
          <td class="text-right">
            {{ index + 1 }}
          </td>
          <td class="text-center">
            <span>{{ vesselManningHistory.date_transferred | moment('D MMM YYYY') }}</span>
          </td>
          <td class="text-center">{{ vesselManningHistory.manningFrom }}</td>
          <td class="text-center">{{ vesselManningHistory.manningTo }}</td>
          <td class="text-center">
            <template v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline">
              <button class="btn btn-sm btn-xs btn-outline-info mr-2 font-weight-bolder"
                      data-toggle="modal"
                      data-target="#view-vessel-manning-history"
                      @click="viewVesselManningHistory = vesselManningHistory"
              >
                <span class="fas fa-eye"></span>
                View
              </button>
              <button class="btn btn-sm btn-xs btn-danger mr-2 font-weight-bolder"
                      title="Delete This Management record"
                      @click="confirmDeleteVesselManningHistory(vesselManningHistory.id)"
              >
                <span class="fas fa-trash"></span>
              </button>
            </template>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <edit-manning-history :view-vessel-manning-history="viewVesselManningHistory"></edit-manning-history>
  </div>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {dataMixin} from '@/mixins/dataMixin';
import {gateMixin} from '@/mixins/gateMixin';
import AppLoading from '@/components/elements/AppLoading';
import AddManningHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-manning/AddManningHistory';
import EditManningHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-manning/EditManningHistory';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'ManningHistoryIndex',

  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],
  components: {AppLoading, AddManningHistory, EditManningHistory},

  data() {
    return {
      viewVesselManningHistory: {},
    };
  },

  methods: {
    ...mapActions([
      'getVesselManningHistories',
      'deleteVesselManningHistory',
      'getAllManningKeys',
    ]),

    async confirmDeleteVesselManningHistory(vesselId) {
      if (await this.confirmDeleteAlert()) {
        let deleteVesselManningHistory = await this.deleteVesselManningHistory({vesselId: vesselId});
        if (deleteVesselManningHistory) this.successAlert('Manning Vessel History Record Successfully Deleted', 'DELETE');
      }
    },

  },

  computed: {
    ...mapGetters([
      'vesselManningHistories',
      'allManningKeys',
      'vesselInfo',


    ]),
  },

  created() {
    this.getAllManningKeys();
      this.getVesselManningHistories({vesselId: this.$route.params.id});
  },

  watch: {
    // 'vesselInfo.id'() {
    //   this.getVesselManningHistories({vesselId: this.$route.params.id});
    // },

  },

};
</script>

<style scoped>

</style>
